import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { mapDispatchToActions } from '@sparefoot/react-core/utils';

import {
	getFacilityPhoneNumber,
	getFacilityCardPhoneNumber,
} from 'store/modules/facilities';
import { getTollfreePhoneNumber } from 'store/modules/phone';

import SearchPin from 'components/search/SearchMap/SearchPin';
import { SearchInfoWindow } from 'components/search/SearchMap';
import { NewFacilityCard } from 'components/facility/FacilityCard';

export const enhance = compose(
	connect(
		undefined,
		{
			getFacilityPhoneNumber,
			getTollfreePhoneNumber,
			getFacilityCardPhoneNumber,
		},
		mapDispatchToActions,
	),
	withHandlers({
		// when selecting the pin, we should show the mini facility card and select the facility card
		handleSelect:
			({ handleFacilitySelected, handlePinSelected, facility }) =>
			() => {
				handleFacilitySelected(facility.id);
				handlePinSelected();
			},
		// when deselecting the pin, we should hide the mini facility card and deselect the facility card
		handleDeselect:
			({ handleFacilityDeselected, handlePinDeselected }) =>
			() => {
				handleFacilityDeselected();
				handlePinDeselected();
			},
		handleMouseEnter:
			({ handleFacilitySelected, facility, pinSelected }) =>
			() => {
				if (pinSelected) return;
				handleFacilitySelected(facility.id);
			},
		handleMouseLeave:
			({ handleFacilityDeselected, pinSelected }) =>
			() => {
				if (pinSelected) return;
				handleFacilityDeselected();
			},
	}),
);
export function SearchMarker(props) {
	return (
		<>
			<SearchPin
				{...props}
				onClick={props.handleSelect}
				onMouseEnter={props.handleMouseEnter}
				onMouseLeave={props.handleMouseLeave}
			/>
			{props.showMiniCard && (
				<>
					<NewFacilityCard // here for the mobile version
						{...props}
						baseUrl={props.baseUrl}
						getFacilityCardPhoneNumber={() =>
							props.actions.getFacilityCardPhoneNumber(
								props.location.city,
								props.location.state,
								props.facility.id,
							)
						}
						onVisible={props.handleFacilityCardVisible}
						bottomMap
						miniCard
					/>
					<SearchInfoWindow {...props} />
				</>
			)}
		</>
	);
}

SearchMarker.propTypes = {
	selected: PropTypes.bool,
	handleSelect: PropTypes.func.isRequired,
	handleMouseEnter: PropTypes.func.isRequired,
	handleMouseLeave: PropTypes.func.isRequired,
	handleFacilityCardVisible: PropTypes.func.isRequired,
	showMiniCard: PropTypes.bool.isRequired,
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
	}).isRequired,
	facility: PropTypes.shape({
		id: PropTypes.number.isRequired,
	}).isRequired,
	baseUrl: PropTypes.string,
	actions: PropTypes.shape({
		getFacilityCardPhoneNumber: PropTypes.func.isRequired,
	}).isRequired,
};

export default enhance(SearchMarker);
